module.exports = __webpack_public_path__ + "static/img/city2.77d1ac1.png";


//////////////////
// WEBPACK FOOTER
// ./public/citybrianImg/city2.png
// module id = B4Lj
// module chunks = 0